export default __webpack_public_path__ + "static/media/support.eb4b3e01.png";